window.productSliderModules = (function () {
  const preload = 2;
  async function saveProductToLocation(type = "all") {
    let productAfter,
      previousSlug,
      productBefore,
      nextSlug,
      productAfterNew,
      productBeforeNew;
    for (let i = 0; i < preload; i++) {
      let newWrapSlider = document.querySelector(".swipe-wrap");
      console.log(newWrapSlider);
      if (type == "prepend" || type == "all") {
        productAfter = newWrapSlider?.querySelectorAll(".product-packaged")[0];
        previousSlug = productAfter?.querySelector("[data-after]").dataset.after;
        productAfterNew = await addProductNew(
          newWrapSlider,
          previousSlug,
          "prepend"
        );
      } else if (type == "append" || type == "all") {
        productBefore =
          newWrapSlider.querySelectorAll(".product-packaged")[
            newWrapSlider.querySelectorAll(".product-packaged").length - 1
          ];
        nextSlug = productBefore.querySelector("[data-before]").dataset.before;
        console.log(nextSlug, previousSlug)
        if (nextSlug && nextSlug != previousSlug) {
          productBeforeNew = await addProductNew(
            newWrapSlider,
            nextSlug,
            "append"
          ); 
        }
      }
    }
  }

  async function loadProduct(type = "all") {
    let productAfter,
      previousSlug,
      productBefore,
      nextSlug,
      productAfterNew,
      productBeforeNew;
    for (let i = 0; i < preload; i++) {
      let newWrapSlider = document.querySelector(".swipe-wrap");
      if (type == "prepend" || type == "all") {
        productAfter = newWrapSlider?.querySelectorAll(".product-packaged")[0];
        previousSlug = productAfter?.querySelector("[data-after]").dataset.after;
        productAfterNew = await addProductNew(
          newWrapSlider,
          previousSlug,
          "prepend"
        );
      } else if (type == "append" || type == "all") {
        productBefore =
          newWrapSlider.querySelectorAll(".product-packaged")[
            newWrapSlider.querySelectorAll(".product-packaged").length - 1
          ];
        nextSlug = productBefore.querySelector("[data-before]").dataset.before;
        productBeforeNew = await addProductNew(
          newWrapSlider,
          nextSlug,
          "append"
        );
      }
    }
  }

  async function getProductDocumentNew(slug) {
    const res = await fetch(`/${slug}`, { cache: "reload" });
    const doc = await res.json();
    let sectionId = document
      .querySelector(".main-product")
      .getAttribute("id")
      .replace("MainProduct-", "");
    return doc[`${sectionId}`];
  }

  async function addProductNew(slider, slug, mode) {
    if (!slug) {
      return;
    }
    let sectionId = document
      .querySelector(".main-product")
      .getAttribute("id")
      .replace("MainProduct-", "");
    slug = slug + `?sections=${sectionId}`;
    return getProductDocumentNew(slug)
      .then((productDoc) => saveProduct(mode, productDoc, slug))
      .then(() => {
        return true;
      });
  }

  function saveProduct(
    mode,
    doc,
    slug = location.pathname.replace("/products/", "")
  ) {
    return true;
    let listSliderProduct = localStorage.getItem("listSliderProduct");
    if (listSliderProduct == null) {
      listSliderProduct = {};
    } else {
      listSliderProduct = JSON.parse(listSliderProduct);
    }
    listSliderProduct[slug] = doc;
    let dataSaveLocation = JSON.stringify(listSliderProduct);
    localStorage.setItem("listSliderProduct", dataSaveLocation);
    return true;
  }

  return {
    saveProductToLocation,
    loadProduct,
  };
})();

window.loadProductSliderModule = async () => {
  // Código de inicialización aquí  
  await window.productSliderModules.saveProductToLocation();
  await window.productSliderModules.loadProduct();
  console.log('cargo script');
};

document.addEventListener("DOMContentLoaded", window.loadProductSliderModule);
